import defaultConfig from '.';

export default {
  ...defaultConfig,
  loadGDPRScript: true,
  placementOptions: {
    panorama_top: {
      placeholder: [
        {
          media: 'largeUp',
          width: 980,
          height: 120,
          margin: '10px auto 0',
        },
      ],
    },
    panorama_extra: {
      placeholder: [
        {
          media: 'largeUp',
          width: 980,
          height: 120,
          margin: '10px auto',
        },
      ],
    },
    skyscraper_1: {
      placeholder: [
        {
          media: 'largeUp',
          width: 250,
          height: 600,
          margin: '0',
        },
      ],
    },
    dubbelpanorama1: {
      placeholder: [
        {
          media: 'smallOnly',
          width: 320,
          height: 160,
          margin: '10px auto',
        },
      ],
    },
  },
};
